import React from 'react';
import PortfolioReturnsSettings from '../settings/PortfolioReturnsSettings';
import { PortfolioReturnsComponentState } from '../store/component/PortfolioReturnsComponentState';
import './PortfolioReturnsToolbar.scss';
import { PortfolioReturnsConfigurationState } from '../store/configuration/PortfolioReturnsConfigurationState';
import ZoomButtons from 'utils/components/Zoom/ZoomButtons';
import WidgetToolbar from 'widgets/WidgetToolbar/WidgetToolbar';
import { useWidgetPortfolioSelectionStatus } from 'widgets/hooks';
import SelectionStatus from 'portfolio/components/SelectionStatus';
import { useWidgetMessagesAdornedWithSymbologyWarning } from 'widgets/WidgetSymbologyWarning';

interface PortfolioReturnsToolbarProps {
    availableBasisDays: Date[];
    component: PortfolioReturnsComponentState;
    config: PortfolioReturnsConfigurationState;
    zoomLabel: string;
    widgetHeight: number;
    onComponentChange: (
        component: Partial<PortfolioReturnsComponentState>
    ) => void;
    onConfigChange: (
        component: Partial<PortfolioReturnsConfigurationState>
    ) => void;
}

export default function PortfolioReturnsToolbar(
    props: PortfolioReturnsToolbarProps
) {
    const {
        component,
        config,
        availableBasisDays,
        onComponentChange,
        onConfigChange,
        zoomLabel,
    } = props;

    const { portfolioSelectionRequirements, hasValidSelection } =
        useWidgetPortfolioSelectionStatus();

    const messages = useWidgetMessagesAdornedWithSymbologyWarning();

    const canZoom = !(component.fromDate && component.toDate);

    return (
        <div className="PortfolioReturnsToolbar panel-header">
            <div className="toolbar">
                <SelectionStatus
                    selectionRequirements={portfolioSelectionRequirements}
                    widgetName={'Portfolio Returns Widget'}
                />
            </div>
            <WidgetToolbar
                fixedItems={
                    hasValidSelection && canZoom ? (
                        <ZoomButtons
                            zoomLabel={zoomLabel}
                            allowZoomOut={true}
                        />
                    ) : undefined
                }
                hideMessages={!hasValidSelection}
                messages={messages}
                showEditLayout={hasValidSelection}
                settingsHeader="Portfolio Returns Settings"
                settingsClassName="PortfolioReturnsSettingsModal"
                settingsBody={
                    <PortfolioReturnsSettings
                        availableBasisDays={availableBasisDays}
                        component={component}
                        config={config}
                        onComponentChange={onComponentChange}
                        onConfigChange={onConfigChange}
                    />
                }
            />
        </div>
    );
}
